module.exports = __webpack_public_path__ + "media/images/ogp-0b63472fad00264a8ffd0987953df57d.jpg";